import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react";
import { styled } from "@mui/system";
import { LinearProgress } from "@mui/material";
import Color from "@/tool/color";
import { isEmpty, round } from "lodash";
import Empty from "@/component/empty";
import moPortrait from "../../../store/portrait";
import moIndex from "@/page/index/store";

interface IProps {
  list: Array<any>;
}
interface IState {}
const DProgress = styled(LinearProgress)({
  width: "120px",
  borderRadius: "4px",
  backgroundColor: Color.blackColor(0.04),
});
const colorList = ["one", "three"];
const SexDistributon = (props: IProps, state: IState) => {
  const { list } = props;
  const { isMock } = moIndex;

  const getManList = useMemo(() => {
    if (!isEmpty(list)) {
      const manNum = Math.ceil(list[0]?.value);
      const res: any = [];
      for (let j: number = 0; j < manNum; j += 1) {
        res.push(j);
      }
      return res;
    }
    return [];
  }, [list]);

  const getWomanList = useMemo(() => {
    if (!isEmpty(list)) {
      const womanNum = 100 - Math.ceil(list[0]?.value);
      const res: any = [];
      for (let j: number = 0; j < womanNum; j += 1) {
        res.push(j);
      }
      return res;
    }
    return [];
  }, [list]);

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section
      className="sex-distribution-content"
      style={{
        backgroundImage: isMock
          ? "url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)"
          : "",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
      }}
    >
      <section className="sub-title">性别分布</section>
      {!isEmpty(list) ? (
        <section className="sex-distribution-chart">
          <section className="sex-svg">
            {getManList?.map((item: any) => (
              <span key={item.toString()} className="sex-icon-item">
                <img
                  src="https://file.smartsalary.cn/web-img%402.0/market/image/man.png"
                  alt=""
                  width={14}
                />
              </span>
            ))}
            {getWomanList?.map((item: any) => (
              <span key={item.toString()} className="sex-icon-item">
                <img
                  src="https://file.smartsalary.cn/web-img%402.0/market/image/woman.png"
                  alt=""
                  width={14}
                />
              </span>
            ))}
          </section>
          <section className="sex-progress">
            {list &&
              list?.map((item: any, i: number) => (
                <section key={`${i.toString()}`} className="progress-item">
                  <p>
                    <span>{item?.name}</span>
                    <DProgress
                      variant="determinate"
                      value={round(item?.value, 1)}
                      className={colorList[i]}
                    />
                  </p>
                  <span className="value">{round(item.value, 1)}%</span>
                </section>
              ))}
          </section>
        </section>
      ) : (
        <Empty />
      )}
    </section>
  );
};

export default observer(SexDistributon);
